export class UserServiceProfile {
  public id?: number;
  public description: string;
  public responsableService?: boolean;
  public responsableClassement?: boolean;
  public responsableDistribution?: boolean;
  public validationDistribution?: boolean;
  public AccesDocumentConfidentiels?: boolean;
  public supprimerDocument?: boolean;
  public repondreALaPlaceDe?: boolean;
  public refuserCreationDocumentEntrant?: boolean;
  public refuserCreationDocumentSortant?: boolean;
  public refuserModification?: boolean;
  public interdireRepondreDocument?: boolean;
  public refuserAjoutDistribution?: boolean;
  public refuserAjoutFichier?: boolean;
  public refuserSuppressionFichier?: boolean;
  public refuserAjoutVersionFichier?: boolean;
  public RefuserVisualisationVersionFichiers?: boolean;
  public refuserModificationFichier?: boolean;
  public refuserVisualisationFichier?: boolean;
  public cacherStatutMultiples?: boolean;
  public cacherFichiers?: boolean;
  public refuserMauvaisRoutage?: boolean;
  public accesMauvaisRoutage?: boolean;
  public AccesRetourCourriers?: boolean;
  public AccesStatistiques?: boolean;
}
